export const components = {
  Button: {
    variants: {
      menu_outline: {
        color: 'interaction.main.default',
        _hover: {
          bg: 'interaction.main.default',
          color: 'standard.white',
          _disabled: {
            bg: 'interaction.support.disabled',
            color: 'interaction.support.disabled-content',
          },
        },
      },
    },
  },
  Menu: {
    baseStyle: {
      item: {
        _hover: {
          bg: 'brand.secondary.100',
          _disabled: {
            bg: 'standard.white',
          },
        },
        _focus: {
          bg: 'brand.secondary.100',
        },
      },
      list: {
        borderRadius: '4px',
        mt: '0px',
      },
    },
  },
  Radio: {
    baseStyle: {
      container: {
        _focusWithin: {
          outline: 'none', // Get rid of outer border when selected
        },
      },
    },
  },
  Checkbox: {
    baseStyle: {
      container: {
        _focusWithin: {
          outline: 'none', // Get rid of outer border when selected
        },
      },
    },
  },
  SingleSelect: {
    baseStyle: {
      item: {
        _active: {
          bg: 'brand.primary.200',
        },
      },
    },
  },
}
